import PropTypes from "prop-types";
import React, { useRef } from "react";

import { createClassNameString } from "../../utils";
import { Text } from "../../Text";
import { TextColors, TextTypes } from "../../constants";

import "./styles.scss";

export const RadioOld = ({ version, ...props }) => {
  if (version === "v1") {
    return <RadioV1 {...props} />;
  } else if (version === "v2") {
    return <RadioV2 {...props} />;
  } else {
    console.error(`Invalid radio version ${version}`);

    return null;
  }
};

RadioOld.propTypes = {
  version: PropTypes.string,
};

RadioOld.defaultProps = {
  version: "v1",
};

const RadioV2 = ({
  checked,
  className,
  label,
  labelClassName,
  name,
  onChange,
  onClick,
  radioClassName,
  value,
  ...props
}) => {
  // This adds the functionality of being able to select the button by clicking the text or the checkbox
  const inputElement = useRef();

  return (
    <div
      className={createClassNameString(["apti-CL apti-Radio--container", className])}
      onClick={() => {
        onClick({ target: inputElement?.current });
        onChange({ target: inputElement?.current });
      }}
    >
      <input
        checked={checked}
        className={createClassNameString(["apti-Radio", !label && "no-label", radioClassName])}
        name={name}
        ref={inputElement}
        type="radio"
        value={value}
        {...props}
      />

      {label && (
        <Text
          className={createClassNameString(["apti-Radio--label", labelClassName])}
          color={TextColors.grey}
          type={TextTypes.label}
        >
          {label}
        </Text>
      )}
    </div>
  );
};

const RadioV1 = ({
  checked,
  className,
  label,
  labelClassName,
  name,
  onChange,
  onClick,
  radioClassName,
  value,
  ...props
}) => (
  <div className={createClassNameString(["apti-CL apti-Radio--container", className])}>
    <input
      checked={checked}
      className={createClassNameString(["apti-Radio", !label && "no-label", radioClassName])}
      name={name}
      onChange={onChange}
      onClick={onClick}
      type="radio"
      value={value}
      {...props}
    />

    {label && (
      <Text
        className={createClassNameString(["apti-Radio--label", labelClassName])}
        color={TextColors.grey}
        type={TextTypes.label}
      >
        {label}
      </Text>
    )}
  </div>
);

const radioV1PropTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.string.isRequired,
};

const radioV1DefaultValues = {
  checked: false,
  className: undefined,
  label: undefined,
  labelClassName: undefined,
  onClick: () => {},
  value: "",
};

RadioV1.propTypes = radioV1PropTypes;
RadioV1.defaultProps = radioV1DefaultValues;

RadioV2.propTypes = radioV1PropTypes;
RadioV2.defaultProps = radioV1DefaultValues;
